import React, { useEffect, useState, useLayoutEffect } from 'react'
import { useMemo } from 'react';

import { Spinner } from 'react-bootstrap';
// import { createNews } from '../api/admin-api';
import Cookie from 'react-cookies';
import { DeleteForever } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { newSlide } from '../../api/api';
const CreateNews = () => {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [newsImages, setNewsImages] = useState([]);
  const [newsImagesOriginal, setNewsImagesOriginal] = useState();


  const handleInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setData({
      ...data, [name]: value
    })
  }
  const handleSubmit = async (e) => {

    e.preventDefault()
    let formId = document.getElementById('createNewsForm');
    const formData = new FormData(formId);
    formData.delete('file []');
    newsImages.forEach((value, key, data) => {
      if(typeof(value) === 'object'){
          formData.append('file []', value);
      }
  })
    console.log(formData);
	const res = await newSlide(formData);
      console.log(res);
      if(res.success){
        Swal.fire({
			title: "Successful",
			text: res.message,
			// timer: 3000,
			icon: 'success',
			confirmButtonColor: '#320808'
		})
        e.target.reset();
		setNewsImages([]);
      }else{
        Swal.fire({
			title: "Failed",
			text: res.message,
			// timer: 3000,
			icon: 'error',
			confirmButtonColor: '#320808'
		})
      }
    
  } 
  

  useEffect(() => {
    document.title = 'New Slide | Bida Sport Club'
  }, [])
  return (
    <div className='d-flex justify-content-center align-items-center'
    style={{ 
      backgroundColor: 'whitesmoke'
     }}
    >
      <div className=' container card my-5 mx-4 px-4 '
      
      >
          <div className="">
            <p className="small-header ms-4 mt-4"> New Slide Image </p>
            
        <form method='POST' onSubmit={handleSubmit}
        id="createNewsForm"
        >
          <div className="row mb-4">
            <div className="col-12">
                <div className="card mb-4">
                    <div className="card-body">
                    
                        <div className='d-flex justify-content-center align-items-center'>
                        <input type="file"  
                        onChange={(e) => {
                            console.log(e.target.files)
                            // let media = [...newsImages.media,...e.target.files]
                          setNewsImages([...newsImages,...e.target.files])
                            // dispatch(addProduct({media}))
                        }}
                        style={{display:"none"}} placeholder="Type here" name='file []' multiple className="form-control" id="uploadImages"
                        />
                        <label  htmlFor='uploadImages' className='upload-images-label d-flex justify-content-center align-items-center' style={{
                                display: "block",
                                width: "90%",
                                height:140,
                                borderStyle:'dashed',
                                borderColor:'GrayText',
                                borderWidth:0.5,
                                borderRadius:5,
                            }
                        }>
                            <span style={{fontSize:16}}> Click to Add Image</span>
                        </label>
                        </div>
                        <div className='products-container d-flex justify-content-start align-items-center m-2'>
                            {
                                newsImages && newsImages.map(function(img,index){
                                    return (
                                        <div  key= {index} className='product-container d-flex-column mx-2 justify-content-center align-items-center' style={{
                                            cursor: "pointer",
                                            borderRadius:5,
                                            borderWidth:1,
                                            borderColor:"#e0e2e3",
                                }} >
                                        <img
                                            src={ typeof(img) === 'object' ? URL.createObjectURL(img) : img}
                                            alt={index+"product_image"}
                                            width={80}
                                            height={80}
                                        />
                                        {/* <div className='delete-product d-flex justify-content-center align-items-center' style={{color:'#a50f0f'}} onClick={()=>{
                                            setNewsImages(newsImages.filter((_,ind)=> ind != index))
                                        }}>
                                            <i className="material-icons md-delete_forever"></i>
                                        </div> */}
                                        <DeleteForever
                                        className='d-flex justify-content-center align-self-center justify-contents-center'
                                        color='error'
                                        onClick={() => setNewsImages(newsImages.filter((_,ind)=> ind != index))}
                                        />
                                </div>
                                    )
                                })
                            }
                        </div>
                      <small className='text-danger' style={{ 
                        fontSize: 12
                       }}> <b>Note: Not more than one image. </b> </small> 
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className=" mx-4">
                    <div className="form-group my-1">
                        <label className="text-muted news-title"> Slide Title </label>
                        <input 
                        id='title'
                        name='title'
                        onChange={handleInput}
                        className="form-control form-control-md" type={'text'} placeholder='Enter News Title' required />
                    </div>
                </div>
            </div>
            <div className=" col-12">
                <div className="mx-4">
                    
                    <button 
                    // onClick={handleSubmit}
                    // type='submit' 
                    className="btn form-control btn-lg btn-color read-btn mt-2">
					Save Slide
                    </button>
                </div>
                
            </div>
          </div> 
        </form>
        </div>
      </div>
    </div>
  )
}

export default CreateNews
